// 权益列表
export const equityList = ['1M+ step-by-step videos', 'Answer accuracy exceeds 90%', 'Unlimited snap & chat', 'Unlimited solutions for PDF files'];
// 订阅埋点source
export const sSourceMap = {
  PLUS: 1, // 固定plus入口
  PLUGIN: 2, // 插件引导支付
  SUPER_AI: 3, // 命中superai，点击订阅
  SUBE_LEFT: 4, // 命中卡次数，到达聊天次数/pdf上传
  QUESTION_VIDEO_POP: 5, // 解题视频上方充值气泡按钮
  OVER_VIDEO_MAX_TIME: 6, // 解题视频30s点击订阅
  ROI_TEST_PLAN_C_A: 9, // question roi测试 planC-A
  ROI_TEST_PLAN_C: 14, // question roi测试 planC-C
  OTHERS: 7, // 其它。
  SEARCH_HOME_LEFT: 11, // search首页卡次数
  SEARCH_DETAIL_LEFT: 12, // search详情页卡次数
  PAY_RETENTION_EMAIL: 10, // 支付挽留邮件
  GLOABAL_SEARCH_INPUT: 13, // 全局头部公共搜索
  QUESTION_SEARCH: 16, // question页面默认
  QUESTION_VIDEO: 15, // question页面解题视频
  QUESTION_YES: 17, // question页面点击yes引导chat按钮
  QUESTION_NO: 19, // question页面点击no引导chat按钮
  QUESTION_SIDEBAR: 18, // question页面侧边栏引导chat
  BILLING_LIST_SUBSCRIBE_BUTTON: 20, // 订阅列表的订阅按钮
  HEADER_NAV_USER_INFO_DROPDOWN: 21, // 通过个人详情点击去支付（顶部导航个人信息下拉）
  RENEW_IN_BILLING_PAGE: 22, // billing页面继续订阅按钮
  COUNT_DOWN_POPUP: 23, // 倒计时弹窗
  COUNT_DOWN_BANNER: 24, // 倒计时banner
  QUESTION_VIP_SUBSCRIBE: 30, // question会员权益订阅
  QUESTION_302_POPUP: 31, // 302广告弹框订阅
  QUESTION_BOTTOM_BANNER: 32, // question底部banner订阅
  QUESTION_UNIVERSITY_HIDDEN: 33, // question 大学遮挡
};
